import { Button } from "@/components/ui/button";
import { useT } from "@/features/onboarding/i18n";

export function ScanStatus({
  msg, kind, onRetry,
}: {
  msg: string | null;
  kind: "info" | "success" | "error";
  onRetry?: () => void;
}) {
  const t = useT();
  if (!msg) return null;
  const c = kind === "error" ? "text-destructive" : kind === "success" ? "text-emerald-700" : "text-foreground font-medium";
  return (
    <p className={"text-xs mt-1.5 " + c}>
      {msg}
      {onRetry && (
        <>
          {" "}
          <Button type="button" variant="link" onClick={onRetry} className="h-auto p-0 text-xs align-baseline">
            {t("wiz.tryAgain")}
          </Button>
        </>
      )}
    </p>
  );
}
